
import { Component, Prop, Watch,Emit,FormComponentBase} from "@/lib";
@Component({name:"hi-checkbox"})
export default class HiCheckbox extends FormComponentBase {
  @Prop({type: Array,required: true,default: () => { return [];}})
  value: Array<string>;

  @Prop({type: Array,default: () => {return [];}})
  checkboxList: Array<any>;

  get requiredRule() {
    return {
      required: true,
      type: "array",
      min: 1,
      message: this.L("Validate.PleaseSelect", this.L(this.labelKey)),
      trigger: "change"
    };
  }
}
